import { render } from "./DocumentArchive.vue?vue&type=template&id=7a89fe03"
import script from "./DocumentArchive.vue?vue&type=script&lang=js"
export * from "./DocumentArchive.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__